import { SurveyScope } from './surveyCommon';

export enum DataShareScopeView {
  Insights = 'insights',
  Downloads = 'downloads',
  Survey = 'survey',
  Messaging = 'messaging'
}

export enum DataScopeAccess {
  Full = 'full',
  Partial = 'partial',
  None = 'none'
}

/**
 * Represent the data share scope.
 *
 * We are union of filters that applied when data lookups are done
 *
 * @Example
 * For initiativeId and children initiativeIds
 * Find all surveys that are within startDate and endDate
 * and have utrs within these scopes
 *
 * At some point it could also support sharing just specific UTRs directly
 *
 */
export interface DataScopeSurvey {
  startDate?: Date;
  endDate?: Date;
  scope?: Partial<SurveyScope>;
  views?: DataShareScopeView[];
  access?: DataScopeAccess;
}

export interface DataScope {
  survey?: DataScopeSurvey;
}

export interface CombinedDataScopeAccess extends DataScopeSurvey {
  access: DataScopeAccess;
  views: DataShareScopeView[];
}
